import { SkeletonModule } from 'primeng/skeleton'
import { EncabezadoPaginaComponent } from './components/encabezado-pagina/encabezado-pagina.component'
import { CommonModule } from '@angular/common'
import { LOCALE_ID, NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgSelectModule } from '@ng-select/ng-select'
import { QRCodeComponent } from 'angularx-qrcode'
import { CURRENCY_MASK_CONFIG, CurrencyMaskConfig, CurrencyMaskModule } from 'ng2-currency-mask'
import { ClipboardModule } from 'ngx-clipboard'
import { NgxDaterangepickerBootstrapModule } from 'ngx-daterangepicker-bootstrap'
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer'
import { MessageService } from 'primeng/api'
import { AutoCompleteModule } from 'primeng/autocomplete'
import { BadgeModule } from 'primeng/badge'
import { ButtonModule } from 'primeng/button'
import { CheckboxModule } from 'primeng/checkbox'
import { ChipModule } from 'primeng/chip'
import { ContextMenuModule } from 'primeng/contextmenu'
import { DatePicker } from 'primeng/datepicker'
import { DividerModule } from 'primeng/divider'
import { DragDropModule } from 'primeng/dragdrop'
import { Drawer, DrawerModule } from 'primeng/drawer'
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog'
import { FieldsetModule } from 'primeng/fieldset'
import { FileUploadModule } from 'primeng/fileupload'
import { GalleriaModule } from 'primeng/galleria'
import { IconField } from 'primeng/iconfield'
import { InputIcon } from 'primeng/inputicon'
import { InputNumberModule } from 'primeng/inputnumber'
import { MultiSelectModule } from 'primeng/multiselect'
import { PanelModule } from 'primeng/panel'
import { ProgressBarModule } from 'primeng/progressbar'
import { RadioButtonModule } from 'primeng/radiobutton'
import { SelectModule } from 'primeng/select'
import { SelectButtonModule } from 'primeng/selectbutton'
import { SpeedDialModule } from 'primeng/speeddial'
import { SplitButtonModule } from 'primeng/splitbutton'
import { SplitterModule } from 'primeng/splitter'
import { TableModule } from 'primeng/table'
import { TabsModule } from 'primeng/tabs'
import { TagModule } from 'primeng/tag'
import { TimelineModule } from 'primeng/timeline'
import { ToastModule } from 'primeng/toast'
import { ToggleButtonModule } from 'primeng/togglebutton'
import { ToggleSwitchModule } from 'primeng/toggleswitch'
import { TooltipModule } from 'primeng/tooltip'
import { TreeTableModule } from 'primeng/treetable'
import { CambioContrasenaComponent } from './components/cambio-contrasena/cambio-contrasena.component'
import { ErrorValidacionBorradoComponent } from './components/error-validacion-borrado/error-validacion-borrado.component'
import { NotFoundComponent } from './components/not-found/not-found.component'
import { OpcionDescargaComponent } from './components/opcion-descarga/opcion-descarga.component'
import { VisorCodigoQrComponent } from './components/visor-codigo-qr/visor-codigo-qr.component'
import { VisorReporteComponent } from './components/visor-reporte/visor-reporte.component'

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
  align: 'right',
  allowNegative: true,
  decimal: ',',
  precision: 2,
  prefix: '$ ',
  suffix: '',
  thousands: '.',
}

@NgModule({
  declarations: [
    EncabezadoPaginaComponent,
    NotFoundComponent,
    VisorCodigoQrComponent,
    VisorReporteComponent,
    OpcionDescargaComponent,
    ErrorValidacionBorradoComponent,
    CambioContrasenaComponent,
  ],
  imports: [
    SkeletonModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    PanelModule,
    TabsModule,
    FieldsetModule,
    SelectModule,
    AutoCompleteModule,
    SplitButtonModule,
    TooltipModule,
    DynamicDialogModule,
    CheckboxModule,
    ToggleSwitchModule,
    DividerModule,
    DatePicker,
    BadgeModule,
    ChipModule,
    TagModule,
    SplitterModule,
    NgSelectModule,
    DragDropModule,
    DrawerModule,
    Drawer,
    ClipboardModule,
    NgxExtendedPdfViewerModule,
    ToggleButtonModule,
    RadioButtonModule,
    MultiSelectModule,
    ContextMenuModule,
    TreeTableModule,
    InputNumberModule,
    CurrencyMaskModule,
    SelectButtonModule,
    SpeedDialModule,
    TimelineModule,
    NgxDaterangepickerBootstrapModule,
    ToastModule,
    ButtonModule,
    QRCodeComponent,
    InputIcon,
    IconField,
    ProgressBarModule,
    FileUploadModule,
    GalleriaModule,
  ],
  exports: [
    SkeletonModule,
    EncabezadoPaginaComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    PanelModule,
    TabsModule,
    FieldsetModule,
    SelectModule,
    AutoCompleteModule,
    SplitButtonModule,
    TooltipModule,
    DynamicDialogModule,
    CheckboxModule,
    ToggleSwitchModule,
    DividerModule,
    DatePicker,
    BadgeModule,
    ChipModule,
    TagModule,
    SplitterModule,
    NgSelectModule,
    DragDropModule,
    DrawerModule,
    Drawer,
    ClipboardModule,
    NgxExtendedPdfViewerModule,
    ToggleButtonModule,
    RadioButtonModule,
    MultiSelectModule,
    ContextMenuModule,
    VisorCodigoQrComponent,
    TreeTableModule,
    InputNumberModule,
    CurrencyMaskModule,
    ErrorValidacionBorradoComponent,
    SelectButtonModule,
    SpeedDialModule,
    TimelineModule,
    NgxDaterangepickerBootstrapModule,
    ToastModule,
    ButtonModule,
    QRCodeComponent,
    InputIcon,
    IconField,
    ProgressBarModule,
    FileUploadModule,
    GalleriaModule,
    CambioContrasenaComponent,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es-CO' },
    { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
    MessageService,
    DialogService,
  ],
})
export class SharedModule {}
